import {makeTileTracker} from './loader.js'
import Source from '../../models/source.js'
import OSM from 'ol/source/OSM'
import XYZ from 'ol/source/OSM'

// The list of all sources available to the app.
let sources = [];

/**
 * buildSources
 * This builds all the OL sources ready for use. It is called in app.js
 */
export function buildSources() {
    buildOsmBW()
    buildOsm()
    buildMapbox()
}

/**
 * getSourceById
 */
export function getSourceById(id)  {
    let s = sources.find(s => s.id == id)
    return s
}

/**
 * buildOsmBw
 * OSM map with atile loader to make it black and white
 */
function buildOsmBW() {
    let olSource = new OSM()
    olSource = makeTileTracker(olSource)
    let source = new Source("osmbw", "Open Street Map in Black and White", olSource, 0.6, 'bw-filter')
    sources.push(source)
}

/**
 * buildOsm
 * Default Open Street Map
 */
 function buildOsm() {
    let olSource = new OSM({})
    olSource = makeTileTracker(olSource)
    let source = new Source("osm", "Open Street Map", olSource, 0.6)
    sources.push(source)
}

/**
 * buildMapbox
 * The simple mapbox map created for the card.
 */
function buildMapbox() {
    let olSource = new XYZ({
        url: 'https://api.mapbox.com/styles/v1/sfreytag/ck8eppozm090e1inlwl6jl798/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoic2ZyZXl0YWciLCJhIjoiY2s4ZXIxazJiMTkwcTNncGU5aHFpZndhbiJ9.oHR7ujDDsCxjC3Rxk-Na4A',
    })
    olSource = makeTileTracker(olSource)
    let source = new Source("aroads", "Our own A-Roads Simple Map", olSource, 1)
    sources.push('sources/pushSource', source)
}
